import { Component } from 'react';
import PropTypes from 'prop-types';
import { warn } from 'js-logger';

export const SegmentAPI = (...args) => {
  if (window.analytics) {
    const [method, ...rest] = args;
    if (rest.length > 0) {
      window.analytics[method].apply(null, rest);
    } else {
      window.analytics[method]();
    }
  }
};

/* eslint prefer-rest-params: 0 */
/* eslint func-names: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint no-plusplus: 0 */
export class Segment extends Component {
  constructor(props) {
    super(props);

    const { apiKey } = props;

    window.analytics = window.analytics || [];
    const { analytics } = window;
    if (!analytics.initialize) {
      if (analytics.invoked) {
        warn('DOM: Segment snippet included twice.');
      } else {
        analytics.invoked = !0;
        analytics.methods = [
          'trackSubmit',
          'trackClick',
          'trackLink',
          'trackForm',
          'pageview',
          'identify',
          'reset',
          'group',
          'track',
          'ready',
          'alias',
          'debug',
          'page',
          'once',
          'off',
          'on',
        ];

        analytics.factory = function (t) {
          return function () {
            const e = Array.prototype.slice.call(arguments);
            e.unshift(t);
            analytics.push(e);
            return analytics;
          };
        };
        for (let t = 0; t < analytics.methods.length; t++) {
          const e = analytics.methods[t];
          analytics[e] = analytics.factory(e);
        }
        analytics.load = function (t, e) {
          const n = document.createElement('script');
          n.type = 'text/javascript';
          n.async = !0;
          n.src = `${
            document.location.protocol === 'https:' ? 'https://' : 'http://'
          }cdn.segment.com/analytics.js/v1/${t}/analytics.min.js`;
          const o = document.getElementsByTagName('script')[0];
          o.parentNode.insertBefore(n, o);
          analytics._loadOptions = e;
        };
        analytics.SNIPPET_VERSION = '4.13.1';
        analytics.load(apiKey);
        analytics.page();
      }
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    SegmentAPI('off');
  }

  render() {
    return false;
  }
}

Segment.propTypes = {
  apiKey: PropTypes.string,
};
